export const storageConfigs = {
  profilePics: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/profile-pics",
    sasToken:"",
    containerName: "profile-pics",
  },
  leads: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/imported-leads",
    sasToken:"",
    containerName: "imported-leads",
  },
  leadsList: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/leads-list",
    sasToken:"",
    containerName: "leads-list",
  },
  emails: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/block-list",
    sasToken:"",
    containerName: "email",
  },
  domains: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/block-list",
    sasToken:"",
    containerName: "domain",
  },
  enrichLeads: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/enrich-leads",
    sasToken:"",
    containerName: "leads",
  },
  companyEnrich: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/company-enrich",
    sasToken:"",
    containerName: "company-enrich",
  },
  multiChannel: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/multi-channel",
    sasToken:"",
    containerName: "multi-channel",
  },
  whitelableLogos: {
    storageAccountUrl:
      "https://b2brocketstorage.blob.core.windows.net/whitelable-logos",
    sasToken:"",
    containerName: "images",
  },
  video: {
    storageAccountUrl: "https://uservideostorage.blob.core.windows.net/user",
    sasToken:"",
    containerName: "user",
  },
};

export const storageConfigsName = {
  profilePics: {
    containerName: "profile-pics/profile-pics",
  },
  "profile-image": {
    containerName: "profile-image/profile-image",
  },
  leads: {
    containerName: "imported-leads/imported-leads",
  },
  leadsList: {
    containerName: "leads-list/leads-list",
  },
  emails: {
    containerName: "block-list/email",
  },
  domains: {
    containerName: "block-list/domain",
  },
  phones: {
    containerName: "block-list/phoneNumber",
  },
  linkedins: {
    containerName: "block-list/linkedin",
  },
  enrichLeads: {
    containerName: "enrich-leads/leads",
  },
  companyEnrich: {
    containerName: "company-enrich/company-enrich",
  },
  multiChannel: {
    containerName: "multi-channel/multi-channel",
  },
  whitelableLogos: {
    containerName: "whitelable-logos/images",
  },
  video: {
    containerName: "user-videos",
  },
   "mailbox-imports": {     
    containerName: "mailbox-imports"
  },
  "email-attachments": {     
    containerName: "email-attachments"
  },
  "agent-files": {
    containerName: "agent-files"
  }
};
